/**
 * The right edge of what the composer is drawn in: the nearest ancestors that
 * clip (overflow, a transform or paint containment, as a drawer does), or the
 * screen.
 */
export const clipRightOf = (element: Element) => {
  let right = window.innerWidth;
  for (let node = element.parentElement; node; node = node.parentElement) {
    const style = getComputedStyle(node);
    if (
      style.overflowX !== 'visible' ||
      style.transform !== 'none' ||
      style.contain.includes('paint')
    ) {
      right = Math.min(right, node.getBoundingClientRect().right);
    }
  }
  return right;
};

/**
 * The preview pane sits beside the menu's card, never past the edge that
 * clips the composer (a drawer, or the screen): it takes the room left there,
 * less the 8px gap and its 4px halo, up to 300px, and hides under 220px.
 * `menu` is the element the pane's CSS reads the room from (the menu or one
 * of its ancestors); `anchor` is inside the chat; `cardRight` is where the
 * card ends on screen.
 */
export const fitPromptPane = (
  menu: HTMLElement,
  anchor: Element,
  cardRight: number
) => {
  const paneRoom = clipRightOf(anchor) - 8 - cardRight - 12;
  menu.style.setProperty(
    '--prompt-pane-room',
    `${Math.max(0, Math.min(300, paneRoom))}px`
  );
  menu.toggleAttribute('data-no-pane-room', paneRoom < 220);
};
